/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import React from 'react';
import { Provider } from 'react-redux';
import UserflowTheme from '@lt/components/themes/userflow';
import { ParallaxProvider } from 'react-scroll-parallax';
import ErrorBoundary from 'src/error/components/ErrorBoundary';
import LazySeamlessTBankAuth from 'src/components/SeamlessTBankAuth';

import Layout from 'src/components/Layout';

import { setPageColors } from 'src/hooks/setPageColors';

// Main container:
import MainContainer from './presentation/MainContainer';

// Redux store:
import { getStore } from './domain/state';

// Contants:
import { MODULE_NAME } from '../../constants';

// Global Styles:
import { GlobalStyle } from './presentation/Styles/GlobalStyles';

const SeoApp = (props) => {
  const { locale, is_mobile, isWhitelabel, wlPartnerSettings } = props;

  try {
    if (isWhitelabel && wlPartnerSettings)
      setPageColors({
        primary: wlPartnerSettings.primary,
        primaryColor: wlPartnerSettings.primaryColor,
        primaryHeader: wlPartnerSettings.primaryHeader,
        primaryHeaderColor: wlPartnerSettings.primaryHeaderColor,
        secondary: wlPartnerSettings.secondary,
        secondaryColor: wlPartnerSettings.secondaryColor,
        secondaryHeader: wlPartnerSettings.secondaryHeader,
        secondaryHeaderColor: wlPartnerSettings.secondaryHeaderColor,
      });
  } catch (e) {
    console.log(e);
  }

  return (
    <ErrorBoundary>
      <Provider store={getStore(props)}>
        <ParallaxProvider>
          <UserflowTheme>
            <Layout appName={MODULE_NAME.SEO} isMobile={is_mobile}>
              <GlobalStyle />
              <MainContainer language={locale} is_mobile={is_mobile} />
            </Layout>

            <LazySeamlessTBankAuth />
          </UserflowTheme>
        </ParallaxProvider>
      </Provider>
    </ErrorBoundary>
  );
};

SeoApp.defaultProps = {
  is_mobile: false,
  client: null,
  locale: 'ru',
};

SeoApp.propTypes = {
  locale: PropTypes.string,
  is_mobile: PropTypes.bool,
  client: PropTypes.shape({}),
};

export default SeoApp;
